export const getFormattedDate = ({ locale, timestamp }) => formatWithIntl({ month: 'long', day: '2-digit' }, timestamp, locale);
export const getFormattedTime = ({ locale, timestamp }) => formatWithIntl({
    minute: '2-digit',
    hour: 'numeric',
}, timestamp, locale);
export const getFormattedDateTime = ({ timestamp, locale }) => formatWithIntl({
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    minute: '2-digit',
    hour: 'numeric',
}, timestamp, locale);
export const formatWithIntl = (options, timestamp, locale) => new Intl.DateTimeFormat(locale || 'en', options).format(new Date(timestamp));
//# sourceMappingURL=formatter.js.map